// extracted by mini-css-extract-plugin
export default {"closedMessageBody":"_3V8rzO3MsloAkByuYXBnx4"};